export const CACHE_BUSTER_PARAM = 'cacheBuster';

const PAGE_LOAD_CACHE_BUSTER = Date.now();

/**
 * Reuse images throughout this page load, but request a fresh URL after a reload or
 * reopening checkout so Slate configuration changes can appear. VEX must have published
 * the updated image; changing this cache key does not trigger image generation.
 */
export const vehicleImageCacheBuster = (): number => PAGE_LOAD_CACHE_BUSTER;
